<script lang="ts">
  import type { Hero3 } from '../../types';

  export let data: Hero3['thankYou'];
</script>

<div
  class="my-auto flex h-auto w-full flex-col items-center justify-center rounded-3xl bg-[#B3D18433] px-4 py-5 py-8 text-center md:min-h-[400px] md:px-10 md:py-10"
>
  <div class="mb-6">
    <span class="hidden md:block">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="132"
        height="132"
        viewBox="0 0 132 132"
        fill="none"
      >
        <path
          d="M65.9981 121C96.3737 121 120.998 96.3758 120.998 66.0001C120.998 35.6245 96.3737 11.0001 65.9981 11.0001C35.6224 11.0001 10.998 35.6245 10.998 66.0001C10.998 96.3758 35.6224 121 65.9981 121Z"
          fill="#8DC63F"
        />
        <path
          d="M41.248 66.0001L57.7481 82.5001L90.7481 49.5001M120.998 66.0001C120.998 96.3758 96.3737 121 65.9981 121C35.6224 121 10.998 96.3758 10.998 66.0001C10.998 35.6245 35.6224 11.0001 65.9981 11.0001C96.3737 11.0001 120.998 35.6245 120.998 66.0001Z"
          stroke="white"
          stroke-width="4"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </span>
    <span class="block md:hidden">
      <svg
        width="60"
        height="60"
        viewBox="0 0 60 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="30" cy="30" r="30" fill="#8DC63F" />
        <rect
          width="37.5"
          height="37.5"
          transform="translate(11.25 11.25)"
          fill="#8DC63F"
        />
        <path
          d="M19.0625 31.5625L25.3125 37.8125L40.9375 22.1875"
          stroke="white"
          stroke-width="3.75"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </span>
  </div>

  <div class="space-y-3">
    <h3 class="!font-bold text-[#161C24] md:text-2xl">
      {data.heading.value}
    </h3>

    <div class="text-sm text-[#111111A3]">
      <p>{data.message.value}</p>
    </div>

    {#if data.response.value}
      <div class="text-sm">
        <p>{data.response.value}</p>
      </div>
    {/if}
  </div>
</div>
